import dayjs from 'dayjs';
import { getDatabase, ref as refDb, onValue, get } from "firebase/database";


export const useServerTime = createGlobalState(function () {

    // null = ยังไม่ได้ค่าจาก Firebase
    // ตัวเลข = offset จริง ซึ่ง 0 เป็นค่าที่ถูกต้อง แปลว่านาฬิกาเครื่องตรงกับ server พอดี
    const serverTimeOffset = ref<number | null>(null);

    // เตือนครั้งเดียวพอ ตัวนี้ถูกเรียกทุกครั้งที่สร้าง job จะรัวจน console/Sentry ท่วม
    let warnedNotLoaded = false;

    // ห้าม throw เด็ดขาด
    //
    // JobBuilder.build() เรียกฟังก์ชันนี้ทุกครั้งที่สร้าง job (สั่งอาหาร / void / ย้ายโต๊ะ /
    // แยกบิล / เปิด-ปิดร้าน / จ่ายเงิน) และ posStore.printPreview() ก็เรียกตรงจาก click handler
    // แอปไม่มี error.vue ของที่ throw ออกมาเลยเด้งเป็นหน้า 500 ทับ POS ทั้งจอ ต้อง reload สถานเดียว
    // เคยทำให้เก็บเงินซ้ำมาแล้ว: ใบเสร็จถูกบันทึกไปแล้วแต่ PAY job ไม่เกิด โต๊ะเลยไม่เคลียร์
    //
    // offset เป็นแค่การชดเชยระดับมิลลิวินาที ยอมใช้เวลาเครื่องไปก่อนคุ้มกว่าหยุดขายทั้งร้าน
    // (เงื่อนไขเดิมเป็น `!serverTimeOffset.value` ซึ่งนับ 0 เป็น "ยังไม่โหลด" ไปด้วย)
    const getCorrectedDayjsInstance = () => {
        const offset = serverTimeOffset.value;

        if (offset == null) {
            if (!warnedNotLoaded) {
                warnedNotLoaded = true;
                console.warn("serverTimeOffset ยังไม่มาจาก Firebase ใช้เวลาของเครื่องไปก่อน");
            }
            return dayjs();
        }

        return dayjs().add(offset, 'millisecond');
    };

    if (serverTimeOffset.value == null) {
        const db = getDatabase();
        const offsetRef = refDb(db, ".info/serverTimeOffset");
        let current = dayjs();
        onValue(offsetRef, (snap) => {
            const offset = snap.val();

            // รับเฉพาะตัวเลข ค่าอื่นปล่อยให้ค้างเป็น null ไว้ จะได้ไม่เอา NaN/undefined
            // ไปบวกกับเวลาแล้วได้ Invalid Date ซึ่งพังเงียบกว่าการใช้เวลาเครื่องเฉย ๆ
            if (typeof offset !== 'number' || !isFinite(offset)) {
                return;
            }

            serverTimeOffset.value = offset;
            warnedNotLoaded = false;


            //if diff more than 1 min, write html to page that time is not correct
            const newTime = dayjs().add(offset, 'millisecond');
            const diff = newTime.diff(current, 'minute');
            if (Math.abs(diff) > 10) {
               // document.body.innerHTML = `<div style="position:fixed; top:0; left:0; width:100%; height:100%; background-color:white; z-index:99999999; font-size: 2rem; text-align:center; padding-top: 10rem;">Your computer time is not correct. Please fix it and reload the page.</div>`
            }

        });
    }

    return { getCorrectedDayjsInstance };
});